module.exports = new __parcel__URL__("LiveDocIntroGADark.45e6357d.svg").toString();